export default __webpack_public_path__ + "static/media/tabla.3178a3bf.png";